import { usePageTitle, useScrollToTop } from "../hooks";
import { PolitiqueSection } from "../components/sections";
import politiqueList from "../data/politiqueList.data";
import presentationBg from "../assets/bg/presentation.webp";
import React from "react";

function Politique() {
    usePageTitle("Politique");
    useScrollToTop();
    return (
        <div>
            <div>
                {/* Background visible uniquement sur >=1280px */}
                <div
                    className="hidden xl:block absolute inset-0 bg-no-repeat ml-80 bg-cover"
                    style={{
                        backgroundImage: `url(${presentationBg})`,
                        zIndex: -1,
                        opacity: 0.25
                    }}
                ></div>

                {politiqueList.map((politique, index) => (
                    <PolitiqueSection
                        key={index}
                        title={politique.title}
                        details={politique.details}
                    />
                ))}
            </div>
        </div>
    );
}

export default Politique;
